import { useEffect, useState } from "react";
import type { CatalogResponse } from "@layer/dashboard/types";
import { api } from "../lib/api";

export function Cli(): JSX.Element {
  const [c, setC] = useState<CatalogResponse | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const load = (): void => {
    setErr(null);
    void api
      .catalog()
      .then(setC)
      .catch((e: Error) => setErr(e.message));
  };

  useEffect(load, []);

  if (err) return <div className="empty">Error: {err}</div>;
  if (!c) return <div className="empty">Loading…</div>;

  const subcommandCount = c.cli.nouns.reduce(
    (acc, n) => acc + n.verbs.length,
    0,
  );

  return (
    <div>
      <h1 className="page-title">
        CLI <button onClick={load}>Refresh</button>
      </h1>
      <p className="hint">
        Operator-only surface (sub-decision E, phase 20). Read-only here —
        execute via the <code>layer</code> binary or <code>pnpm cli …</code>.
      </p>
      <div className="panel">
        <h2>Subcommands · {subcommandCount}</h2>
        {c.cli.nouns.map((n) => (
          <details className="collapsible" key={n.noun} open>
            <summary>
              <code>layer {n.noun}</code>
            </summary>
            <p>{n.synopsis}</p>
            {n.verbs.map((v) => (
              <details className="collapsible" key={v.verb}>
                <summary>
                  <code>
                    layer {n.noun} {v.verb}
                  </code>
                </summary>
                <dl className="kvs">
                  <dt>Synopsis</dt>
                  <dd>{v.synopsis}</dd>
                  <dt>Flags · {v.flags.length}</dt>
                  <dd>
                    <ul>
                      {v.flags.map((f) => (
                        <li key={f.name}>
                          <code>{f.name}</code> ({f.type},{" "}
                          {f.required ? "required" : "optional"}) — {f.synopsis}
                        </li>
                      ))}
                    </ul>
                  </dd>
                  <dt>Example</dt>
                  <dd>
                    <code>{v.example}</code>
                  </dd>
                </dl>
              </details>
            ))}
          </details>
        ))}
      </div>
      <div className="panel">
        <h2>Exit codes · {c.cli.exit_codes.length}</h2>
        <ul>
          {c.cli.exit_codes.map((ec) => (
            <li key={ec.code}>
              <code>{ec.code}</code> — {ec.meaning}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
